<template>
  <button
    v-if="appearance === 'card'"
    type="button"
    class="size-8 rounded-full bg-white/80 flex items-center justify-center cursor-pointer transition-opacity hover:bg-white/90"
    aria-label="Go back"
    @click.prevent="handleBackClick"
  >
    <TIcon :icon="['fas', 'chevron-left']" />
  </button>
  <TButton
    v-else
    variant="white"
    icon
    @click.prevent="handleBackClick"
  >
    <TIcon :icon="['fas', 'chevron-left']" />
  </TButton>
</template>

<script setup lang="ts">
import { ROUTE_BASE_NAME } from '~/constants'

withDefaults(defineProps<{
  appearance?: 'card' | 'default'
}>(), {
  appearance: 'default',
})

const localePath = useLocalePath()
const router = useRouter()
const route = useRoute()
const { locale } = useI18n()

/**
 * Handles the click event of the back button.
 *
 * If the user landed on the RV Rental listing page directly, navigate to the search page.
 * Otherwise, use the browser's back button.
 */
async function handleBackClick() {
  const state = window?.history?.state
  const backPath = state?.back ?? ''
  const canUseBrowserBack = backPath !== ''
    && (backPath.includes(localePath({ name: ROUTE_BASE_NAME.rv_search }, locale.value)))

  if (!canUseBrowserBack) {
    await navigateTo(localePath({ name: ROUTE_BASE_NAME.rv_search, query: route.query }))
    return
  }

  router.back()
}
</script>
